import { BuyGuideVendorBuyOpportunityList } from '../../../components/BuyGuide';

export function BuyGuideVendorBuyOpportunities() {
  return <BuyGuideVendorBuyOpportunityList />;
}
